import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { code: "", type: "percent", value: 10, min_subtotal: 0, active: true, description: "" };

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [draft, setDraft] = useState(null);

  const load = () => api.get("/admin/coupons").then((r) => setCoupons(r.data.coupons));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/admin/coupons", { ...draft, value: Number(draft.value), min_subtotal: Number(draft.min_subtotal) });
      toast.success("Coupon created");
      setDraft(null);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete coupon?")) return;
    await api.delete(`/admin/coupons/${id}`);
    load();
  };

  return (
    <div className="p-8" data-testid="admin-coupons-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="font-mono text-xs text-[#FF3B30] tracking-widest">PROMOTIONS</div>
          <h1 className="font-display text-5xl tracking-tighter mt-2">COUPONS</h1>
        </div>
        <button onClick={() => setDraft({ ...EMPTY })} className="bg-[#FF3B30] text-white px-6 py-3 font-display tracking-widest text-xs hover:bg-black inline-flex items-center gap-2" data-testid="admin-add-coupon">
          <Plus size={14} /> NEW COUPON
        </button>
      </div>

      <div className="border border-black/10 bg-white">
        <table className="w-full text-sm">
          <thead className="font-display tracking-widest text-xs text-black/50">
            <tr className="border-b border-black/10">
              <th className="text-left p-3">CODE</th>
              <th className="text-left p-3">TYPE</th>
              <th className="text-right p-3">VALUE</th>
              <th className="text-right p-3">MIN ORDER</th>
              <th className="text-left p-3">DESCRIPTION</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody>
            {coupons.map((c) => (
              <tr key={c.id} className="border-b border-black/5">
                <td className="p-3 font-display tracking-widest text-[#FF3B30]">{c.code}</td>
                <td className="p-3">{c.type}</td>
                <td className="p-3 text-right">{c.type === "percent" ? `${c.value}%` : `₹${c.value}`}</td>
                <td className="p-3 text-right">₹{c.min_subtotal}</td>
                <td className="p-3 text-black/70 text-xs">{c.description}</td>
                <td className="p-3"><button onClick={() => del(c.id)} className="hover:text-[#FF3B30]"><Trash2 size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {draft && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4">
          <div className="bg-white border border-black/20 w-full max-w-md p-6">
            <h2 className="font-display text-3xl tracking-tighter mb-4">NEW COUPON</h2>
            <div className="space-y-3">
              <Field label="CODE" value={draft.code} onChange={(v) => setDraft({ ...draft, code: v.toUpperCase() })} testId="cf-code" />
              <label className="block">
                <span className="font-display tracking-widest text-[10px] text-black/50">TYPE</span>
                <select value={draft.type} onChange={(e) => setDraft({ ...draft, type: e.target.value })} className="w-full bg-white border border-black/20 px-3 py-2 mt-1">
                  <option value="percent">Percentage off</option>
                  <option value="flat">Flat amount off</option>
                  <option value="shipping">Free shipping</option>
                </select>
              </label>
              <Field label="VALUE" type="number" value={draft.value} onChange={(v) => setDraft({ ...draft, value: v })} testId="cf-value" />
              <Field label="MIN SUBTOTAL (₹)" type="number" value={draft.min_subtotal} onChange={(v) => setDraft({ ...draft, min_subtotal: v })} />
              <Field label="DESCRIPTION" value={draft.description} onChange={(v) => setDraft({ ...draft, description: v })} />
              <div className="flex gap-3 pt-4">
                <button onClick={save} className="bg-[#FF3B30] text-white px-6 py-3 font-display tracking-widest text-xs" data-testid="cf-save">SAVE</button>
                <button onClick={() => setDraft(null)} className="border border-black/30 px-6 py-3 font-display tracking-widest text-xs">CANCEL</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testId }) {
  return (
    <label className="block">
      <span className="font-display tracking-widest text-[10px] text-black/50">{label}</span>
      <input type={type} value={value} onChange={(e) => onChange(e.target.value)} className="w-full bg-transparent border border-black/20 px-3 py-2 mt-1" data-testid={testId} />
    </label>
  );
}
